export const UnresolvedVendorErrorCodeStatus = {
  OPEN: 'OPEN',
  IN_REVIEW: 'IN_REVIEW',
  RESOLVED: 'RESOLVED',
  IGNORED: 'IGNORED',
} as const;

export type UnresolvedVendorErrorCodeStatus =
  (typeof UnresolvedVendorErrorCodeStatus)[keyof typeof UnresolvedVendorErrorCodeStatus];
